import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { BookOpenText, Loader2, ArrowLeft } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const nav = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) {
      toast.error("Email wajib diisi");
      return;
    }
    setBusy(true);
    try {
      await api.post("/auth/request-reset", { email: email.trim() });
      setSent(true);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Gagal mengirim email reset");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FAFAFA] flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="flex items-center gap-2 mb-8">
          <div className="h-10 w-10 rounded-md bg-zinc-900 flex items-center justify-center">
            <BookOpenText className="h-5 w-5 text-white" />
          </div>
          <div>
            <div className="text-lg font-display font-semibold text-zinc-900 tracking-tight">Buku Stok</div>
            <div className="text-xs text-zinc-500">Reset password</div>
          </div>
        </div>
        <div className="border border-zinc-200 rounded-md p-6 bg-white shadow-sm" data-testid="forgot-password-card">
          {sent ? (
            <div className="text-center space-y-4" data-testid="forgot-password-sent">
              <div className="h-12 w-12 rounded-full bg-emerald-50 text-emerald-700 flex items-center justify-center mx-auto text-2xl">
                ✓
              </div>
              <h1 className="text-lg font-semibold text-zinc-900">Cek email Anda</h1>
              <p className="text-sm text-zinc-500">
                Jika <strong className="text-zinc-700">{email}</strong> terdaftar,
                kami sudah mengirim link reset password. Link berlaku 30 menit.
              </p>
              <p className="text-xs text-zinc-400">
                Tidak lihat email? Cek folder Spam / Promotions.
              </p>
              <Button
                variant="outline"
                onClick={() => nav("/login")}
                data-testid="btn-back-to-login"
                className="w-full mt-4"
              >
                Kembali ke Login
              </Button>
            </div>
          ) : (
            <>
              <h1 className="text-xl font-semibold text-zinc-900 mb-1">Lupa Password</h1>
              <p className="text-sm text-zinc-500 mb-5">
                Masukkan email akun Anda. Kami akan kirim link reset password ke email tersebut.
              </p>
              <form onSubmit={onSubmit} className="space-y-3" data-testid="forgot-password-form">
                <div>
                  <Label htmlFor="forgot-email">Email</Label>
                  <Input
                    id="forgot-email"
                    data-testid="forgot-email"
                    type="email"
                    autoComplete="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="anda@email.com"
                    required
                  />
                </div>
                <Button
                  type="submit"
                  disabled={busy}
                  data-testid="forgot-submit"
                  className="w-full bg-zinc-900 hover:bg-zinc-800 h-10 mt-2"
                >
                  {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Kirim Link Reset"}
                </Button>
              </form>
              <Link
                to="/login"
                className="inline-flex items-center gap-1 text-xs text-zinc-500 hover:text-zinc-800 mt-5"
                data-testid="link-back-to-login"
              >
                <ArrowLeft className="h-3 w-3" /> Kembali ke Login
              </Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
